import React from "react";
import { useTranslation } from "react-i18next";
import { AnimatedModal, modalPanelClass } from "../../../components/AnimatedModal";
import CommentInput from "../Events/Components/CommentInput";
import { HiOutlineXMark, HiOutlineDocumentText } from "react-icons/hi2";

interface CommentInputModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAddComment: (comment: any) => void | Promise<void>;
  maxFileSizeMB?: number;
}

const CommentInputModal: React.FC<CommentInputModalProps> = ({
  isOpen,
  onClose,
  onAddComment,
  maxFileSizeMB,
}) => {
  const { t } = useTranslation();

  return (
    <AnimatedModal isOpen={isOpen} onClose={onClose} contentClassName="sm:max-w-2xl">
      <div className={modalPanelClass}>
        <div className="sm:hidden flex justify-center pt-2 pb-1 shrink-0">
          <div className="w-10 h-1 rounded-full bg-gray-300 dark:bg-gray-600" />
        </div>
        <div className="flex items-center justify-between px-4 sm:px-5 py-3 sm:py-4 border-b border-gray-100 dark:border-gray-700 shrink-0">
          <div className="flex items-center gap-2.5">
            <div className="flex items-center justify-center w-9 h-9 rounded-xl bg-[#5932EA]/10 dark:bg-[#5932EA]/20 text-[#5932EA]">
              <HiOutlineDocumentText className="w-5 h-5" strokeWidth={2} />
            </div>
            <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-100">
              {t("newNotes") || "Add a Note"}
            </h2>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="p-2.5 rounded-xl text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
            aria-label={t("close")}
          >
            <HiOutlineXMark className="w-5 h-5" />
          </button>
        </div>
        <div className="p-4 sm:p-5 overflow-y-auto flex-1 min-h-0">
          <CommentInput onAddComment={onAddComment} maxFileSizeMB={maxFileSizeMB} />
        </div>
      </div>
    </AnimatedModal>
  );
};

export default CommentInputModal;
